import { Session } from '../../auth/session';
import authApi, { LoginCredentials, ResetPasswordPayload } from './auth.api';

export async function login(credentials: LoginCredentials): Promise<Session> {
  const raw = await authApi.login(credentials);

  return {
    user: raw.user,
    token: raw.token,
    role: raw.user?.role ?? null,
  };
}

export async function resetPassword(payload: ResetPasswordPayload): Promise<any> {
  return authApi.resetPassword(payload);
}

export async function logout(): Promise<any> {
  return authApi.logout();
}

/**
 * `GET /api/auth/session-status` responds with `{ success, isValid, message, user, token }` —
 * there is no top-level `role`, so it has to be read off the refreshed user. Returning the
 * raw body meant the role was lost on refresh and `normalizeRole` fell back to its default.
 */
export async function getSession(): Promise<Session> {
  const raw = await authApi.sessionStatus();

  return {
    user: raw.user,
    token: raw.token,
    role: raw.user?.role ?? null,
  };
}
